﻿import {GameManager} from "../Game/GameManager";
import {Core} from "../Base/Core";
import {GameCategory, GameScreen} from "../enums";
import {UIBase} from "./Tools/Base/UIBase";
import {NUtils} from "../Utils/NUtils";
import {UIGameObject} from "./Tools/Base/UIGameObject";
import {UIImage} from "./Tools/Base/UIImage";
import {UIText} from "./Tools/Base/UIText";
import {UINineSlice} from "./Tools/Base/UINineSlice";
import {UINineSliceButton} from "./Tools/Base/UINineSliceButton";
import {RewardedAdsBtn} from "./RewardedAdsBtn";

export class CreaturesBankItem extends UIBase {
    Awake() {
        super.Awake();

        this._rect = new PIXI.Rectangle(0, 0, 1, 1);

        this.onAdsShown = this.onAdsShown.bind(this);

        this.back = this.addChild(new UINineSlice("bg-rounding-28px"));
        this.back.tint = 0x000000;
        this.back.alpha = 0.5;

        this.adsPurchases = 0;
        this.nameField = this.addChild(new UIText(""));
        this.softSpeedField = this.addChild(new UIText(""));
        this.purchasesNumberField = this.addChild(new UIText(""));

        this.iconImage = this.addChild(new UIImage());

        this.softBtn = this.addChild(
            new UINineSliceButton("btn-orange", {
                label: "0",
                icon: "ico-gold",
                iconSize: 0.9,
            })
        );
        this.hardBtn = this.addChild(
            new UINineSliceButton("btn-blue", {
                label: "0",
                icon: "ico-diamond",
                iconSize: 0.9,
            })
        );
        this.adsBtn = this.addChild(
            new RewardedAdsBtn("btn-green", {
                label: Core.Localizator.Get("ads"),
                icon: "play-icon",
                iconAlign: "right",
                iconSize: 0.9,
            })
        );

        this.buttonDisabler = null; // PurchaseButtonDisabler buttonDisabler;
        this.buyTutorialHand = this.addChild(new UIGameObject()); // GameObject buyTutorialHand;
        this.creatureData = null; // CreatureData

        this.softBtn.on("pointertap", () => {
            let price = Core.Player.PlanetsSave.CurrentPlanet.GetCreatureSoftPriceWithMultiplayer(this.creatureData.id);
            this.tryToBuy(price);
        });

        this.hardBtn.on("pointertap", () => {
            let price = Core.Player.PlanetsSave.CurrentPlanet.GetCreatureHardPriceWithMultiplayer(this.creatureData.id);
            this.tryToBuy(price);
        });

        this.adsBtn.on("pointertap", () => {
            let creatureId = this.creatureData.id;
            let epoch = Core.GameData.Epochs.GetByCreatureId(creatureId);
            if (!GameManager.gameController.epochById.get(epoch.id).EnoughSpaceForSpawn) {
                Core.UI.noSpace.Show(epoch.id);
            } else {
                Core.Ads.TriggerRewarded(this.onAdsShown);
            }
        });
    }

    Init(creatureId) {
        this.creatureData = Core.GameData.Creatures.Get(creatureId);
        this.nameField.text = Core.Localizator.Get(this.creatureData.creatureName);
        this.iconImage.setImage(`creatures/${this.creatureData.id}`);
    }

    fitLayout(rect = this._rect) {

        this._rect = rect.clone();

        this.position.copyFrom(rect);
        this.back.width = rect.width;
        this.back.height = rect.height;

        let iconRect = rect.clone();
        iconRect.width = rect.width * 0.23;
        iconRect.height = rect.height * 0.8;
        iconRect.x = (rect.width - iconRect.width) * 0.03;
        iconRect.y = (rect.height - iconRect.height) * 0.5;
        this.iconImage.fitRect(iconRect);

        let backRect = new PIXI.Rectangle(this.back.x, this.back.y, this.back.width, this.back.height);

        rect = backRect.clone();
        rect.width = backRect.width * 0.3;
        rect.height = backRect.height * 0.27;
        rect.x = (backRect.width - rect.width) * 0.4;
        rect.y = (backRect.height - rect.height) * 0.1;
        this.nameField.anchor.set(0, 0.5);
        this.nameField.fitLayout(rect);

        rect.height = backRect.height * 0.2;
        rect.y = (backRect.height - rect.height) * 0.45;
        this.softSpeedField.anchor.set(0, 0.5);
        this.softSpeedField.fitLayout(rect);

        rect.height = backRect.height * 0.2;
        rect.width = backRect.width * 0.25;
        rect.y = (backRect.height - rect.height) * 0.78;
        this.purchasesNumberField.anchor.set(0, 0.5);
        this.purchasesNumberField.fitLayout(rect);

        rect = backRect.clone();
        rect.width = backRect.width * 0.2;
        rect.height = backRect.height * 0.4;
        rect.x = (backRect.width - rect.width) * 0.95;
        rect.y = (backRect.height - rect.height) * 0.15;
        this.softBtn.fitLayout(rect);

        rect.y = (backRect.height - rect.height) * 0.85;
        this.hardBtn.fitLayout(rect);

        rect.x = (backRect.width - rect.width) * 0.68;
        rect.y = (backRect.height - rect.height) * 0.85;
        this.adsBtn.fitLayout(rect);

        let contentRect = new PIXI.Rectangle(0, 0, rect.width, rect.height).pad(-rect.width * 0.1, -rect.height * 0.2);
        this.softBtn.content.fitLayout(contentRect);
        this.hardBtn.content.fitLayout(contentRect);
        this.adsBtn.button.content.fitLayout(contentRect);
    }

    updateData() {
        if (!this.creatureData) return;

        let purchasesNumber =
            Core.Player.PlanetsSave.CurrentPlanet.GetCreaturePurchasesSoft(this.creatureData.id) +
            Core.Player.PlanetsSave.CurrentPlanet.GetCreaturePurchasesHard(this.creatureData.id);
        this.purchasesNumberField.text = Core.Localizator.Get("monster_purchases_number", purchasesNumber);
        this.softSpeedField.text = Core.Localizator.Get("monster_soft_speed", NUtils.FormatMoney(this.creatureData.GetSoftPerSecond()));

        let softPriceWithMultiplayer = Core.Player.PlanetsSave.CurrentPlanet.GetCreatureSoftPriceWithMultiplayer(this.creatureData.id);
        let hardPriceWithMultiplayer = Core.Player.PlanetsSave.CurrentPlanet.GetCreatureHardPriceWithMultiplayer(this.creatureData.id);

        this.softBtn.label = NUtils.FormatMoney(softPriceWithMultiplayer.priceValue);
        this.hardBtn.label = NUtils.FormatMoney(hardPriceWithMultiplayer.priceValue);
    }

    OnEnable() {
        this.adsBtn.interactive = true;
    }

    onAdsShown() {
        console.log("ADS: creature rewarded", this.creatureData.id);
        this.adsBtn.interactive = true;
        this.adsPurchases++;
        this.SetAdsButtonActive(true);
        GameManager.gameController.AddCreatureRandomPosition(this.creatureData.id);
        Core.Audio.Play("Upgrade");
        this.fitLayout();
    }

    SetAdsButtonActive(active) {
        this.adsBtn.SetActive(active && this.adsPurchases < Core.GameData.Gameplay.adsCreaturePurchasesPerSession);
    }

    tryToBuy(price) {
        console.log("BUY CREATURE", this.creatureData.id, price);
        Core.Player.PlanetsSave.TutorSave.creature = true;
        Core.UI.tutorial.HideObjectHand(this.softBtn);
        let enoughMoney = Core.Player.EnoughMoney(price);
        if (enoughMoney) {
            let isCreated = GameManager.gameController.AddCreatureRandomPosition(this.creatureData.id);
            if (isCreated) {
                Core.Audio.Play("CreaturePurchase");
                Core.Player.SpendMoney(price, GameCategory.monster, GameScreen.monsters, this.creatureData.creatureName);
                Core.Player.PlanetsSave.CurrentPlanet.AddCreaturePurchase(this.creatureData.id, price.priceType == MoneyType.Soft);
                this.updateData();
                this.fitLayout();
                Core.Analytics.SendMonsterEvent(
                    price.priceType,
                    price.priceValue,
                    this.creatureData.creatureName,
                    Core.Player.PlanetsSave.currentPlanetId.toString(),
                    this.creatureData.creatureRank
                );
            } else {
                Core.UI.noSpace.Show(Core.GameData.Epochs.GetByCreatureId(this.creatureData.id).id);
            }
        } else {
            console.log("BUY CREATURE, NO MONEY", price);
            if (price.priceType == MoneyType.Hard) {
                Core.UI.notEnoughHardMoney.Show();
            } else if (price.priceType == MoneyType.Soft) {
                Core.UI.SetState(UIState.BankSoft);
            }
        }
    }
}
